export default {
    description: {
        booked_by: 'Забронировано пользователем',
        booked_to: 'до',
    },
    link_to_reservation: 'Ссылка на бронирование',
}
